import { analyticsInteraction } from 'utils/analytics';
import { ANALYTICS } from 'constants';

export default {
  init(_, domEl) {
    const branchLocationDrawers = domEl.querySelectorAll('.aem-generic-drawer__bus');
    branchLocationDrawers?.forEach((drawer) => {
      drawer.addEventListener('click', () => {
        const checkbox = domEl.querySelectorAll('.aem-generic-drawer__checkbox')?.[0];
        const analyticsText = drawer.textContent?.trim();

        analyticsInteraction(ANALYTICS.DRAWER, analyticsText, !checkbox?.checked ? ANALYTICS.OPEN : ANALYTICS.CLOSE);
      });
    });
  },
};
